import React, { Component } from 'react';
import styled from 'styled-components';
import moon from './moon.png';
import sun from './sun.png';
import grass from './grass.png';
import cloud from './cloud.svg';
import kanahei from './kanahei.png';

const moonAnimation = 'turning-moon 17s linear infinite, lazy-planet 1s 1s forwards';
const moonAnimationR = 'turning-moon 17s linear infinite, lazy-planet-reverse 1s 0s forwards';
const sunAnimation = 'turning-sun 4s infinite, lazy-planet 1s 1s forwards';
const sunAnimationR = 'turning-sun 4s infinite, lazy-planet-reverse 1s 0s forwards';

class Background extends Component {
  componentDidMount() {
    if (this.props.dayTime === 'night') {
      this.moon.style.animation = moonAnimation;
    } else {
      this.sun.style.animation = sunAnimation;
    }
  }
  shouldComponentUpdate(next) {
    this.background.style.backgroundColor = next.dayTime === 'night' ? 'transparent' : 'white';
    if (this.moon.style.animation && this.sun.style.animation) {
      this.sun.style.animation = next.dayTime === 'night' ? sunAnimationR : sunAnimation;
      this.moon.style.animation = next.dayTime === 'night' ? moonAnimation : moonAnimationR;
    }
    if (!this.sun.style.animation && next.dayTime === 'day') {
      this.sun.style.animation = sunAnimation;
    }
    if (this.sun.style.animation && next.dayTime === 'night') {
      this.sun.style.animation = sunAnimationR;
      this.moon.style.animation = moonAnimation;
    }
    if (!this.moon.style.animation && next.dayTime === 'moon') {
      this.moon.style.animation = moonAnimation;
    }
    if (this.moon.style.animation && next.dayTime === 'day') {
      this.moon.style.animation = moonAnimationR;
      this.sun.style.animation = sunAnimation;
    }

    this.grass.style.opacity = next.dayTime === 'night' ? '0.5' : '1';
    return false;
  }


  render() {
    const { className } = this.props;
    return (
      <div className={className}>
        <div className="background" ref={r => this.background = r}>
          <div className="sky">
            <img className="sun" src={sun} alt="sun" ref={r => this.sun = r} />
            <img className="moon" src={moon} alt="moon" ref={r => this.moon = r} />
            <Clouds />
            <img className="grass" src={grass} alt="grass" ref={r => this.grass = r} />
            <StyledKanahei />
          </div>
        </div>
      </div>
    );
  }
}

const Clouds = () => {
  const clouds = Array.from({ length: 3 }).map((_, i) => (
    <StyledCloud
      key={i}
      delay={i * 10}
      width={Math.floor(Math.random() * 200) + 200}
      height={Math.floor(Math.random() * 200) + 200}
      top={Math.floor(Math.random() * 200)}
      duration={Math.floor(Math.random() * 20) + 20}
    />
  ));
  return clouds;
};

const Cloud = ({ className }) => <img className={className} src={cloud} alt="cloud" />;
const Kanahei = ({ className }) => <img className={className} src={kanahei} alt="kanahei" />;

const StyledKanahei = styled(Kanahei)`
  position: fixed;
  z-index: -10;
  bottom: 0px;
  left:200%;
  animation: walking-kanahei 60s 5s linear infinite, shaking-kanahei 1s 5s linear infinite;
  transition: bottom 1s;
  @keyframes walking-kanahei {
    0% { left:100%; }
    50% { left: -100% }
    100% { left: 200%; }
  }
  @keyframes shaking-kanahei {
    0% { transform: translateY(0px); }
    10% { transform: translateY(5px) ;}
    20% { transform: translateY(0px) ;}
    100% { transform: translateY(0px) ;}
  }
  &:hover {
    bottom: -100px;
  }
`;

const StyledCloud = styled(Cloud)`
  position: fixed;
  opacity: 0.3;
  left: 100%;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  top: ${({ top }) => top}px;
  animation: flying-cloud ${({ duration }) => duration}s ${({ delay }) => delay}s linear infinite;

  @keyframes flying-cloud {
    0% { transform: translateX(0px); }
    100% { transform: translateX(${({ width }) => -(width + 1920)}px) ;}
  }
  @keyframes flying-cloud-mobile {
    0% { transform: translateX(0px); }
    100% { transform: translateX(${({ width }) => -(width + 767)}px) ;}
  }
  @media (max-width:767px) {
    width: ${({ width }) => width / 2}px;
    top: ${({ top }) => top / 2}px;
    animation: flying-cloud-mobile ${({ duration }) => duration}s ${({ delay }) => delay}s linear infinite;
  }
  `;

export default styled(Background)`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: linear-gradient(rgb(70, 68, 68),black);
  
  .background {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: ${({ dayTime }) => (dayTime === 'night' ? 'transparent' : 'white')};
    transition: background-color 1s;
  }
  .sky {
    z-index: -10;
    position: relative;
    width: 100%;
    height: 100%;
    
  }

  .moon {
    position: fixed;
    width: 10em;
    right: 10%;
    bottom: 100%;
    &:hover {
      animation-play-state: paused !important;
    }
    z-index:-10;
  }
  .sun {
    position: fixed;
    width: 10em;
    right: 10%;
    bottom: 100%;
    z-index: 10;
    &:hover {
      animation-play-state: paused !important;
    }
  }
  .grass {
    position: fixed;
    left: 0px;
    bottom: -100px;
    height: 100px;
    width: 100%;
    z-index: 1;
    opacity: ${({ dayTime }) => (dayTime === 'night' ? 0.5 : 1)};
    animation: lazy-grass 1s 1s forwards;
    transition: opacity 1s;
  }
  @keyframes lazy-grass {
    0% { transform: translateY(0px); };
    100% { transform: translateY(-100px); }
  }
  @keyframes lazy-planet {
    0% { top: -10em };
    100% { top: 10% };
  }
  @keyframes lazy-planet-reverse {
    0% { top: 10% };
    100% { top: -10em };
  }
  @keyframes turning-moon {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes turning-sun {
    0% { transform: rotate(0deg); }
    25% { transform: rotate(10deg); }
    50% { transform: rotate(0deg); }
    75% { transform: rotate(-10deg); }
    100% { transform: rotate(0deg); }
  }

  @media (max-width:767px) {
    .sun, .moon {
      width: 30%;
    }
    .grass {
      height: 60px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Background/index.js